import { inject, Injectable } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';

const STORAGE_KEY = 'evaluation-panel-distance-from-right';

@Injectable({ providedIn: 'root' })
export class EvaluationPanelPositionService {
  private readonly localStorage = inject(LocalStorageService);

  public getDistanceFromRight(): number | null {
    const value = this.localStorage.get(STORAGE_KEY, null);

    return typeof value === 'number' && Number.isFinite(value) ? value : null;
  }

  public saveDistanceFromRight(distance: number): void {
    void this.localStorage.set(STORAGE_KEY, Math.round(distance));
  }
}
